<script>
	import { user_token, refresh_token } from "../jwt_store.ts";
	import { login } from "../tastummy_login.ts";

	// get code from url query parameter
	const params = new URLSearchParams(window.location.search);
	const code = params.get("code");
	login(code)
		.then((resp) => {
			$user_token = resp.data.id_token;
			$refresh_token = resp.data.refresh_token;
		})
		.catch((e) => console.log("login e:", e))
		.finally(() => {
			// forward to redirect value if exists
			localStorage.getItem("redirect")
				? (window.location.href = localStorage.getItem("redirect"))
				: (window.location.href = "/");
		});
	let error;
</script>

<div>processing auth token</div>
{#if error}
	<p class="error">{error}</p>
{/if}
